import * as React from 'react';
import { TEAMSNAP_URL } from '../../core/constants';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import * as ShowOrganization from '../../core/gql/queries/show-organizations';
import './forbidden.scss';
import { redirectToOrg } from '../../core/utils';

const DisabledOrg = () => {
  const history = useHistory();
  React.useEffect(
    () => () => {
      history.push({
        pathname: '/',
      });
    },
    []
  );

  const params = useParams<any>();
  const organizationId = +params.orgId;
  const queryOrganization = useQuery(ShowOrganization.BASIC_ORG_QUERY, {
    variables: { organizationId: +organizationId },
  });
  const disabledMessage = queryOrganization?.data?.showOrganization?.disabledMessage;
  const isDisabledOrg = queryOrganization?.data?.showOrganization?.disabled;

  if (!isDisabledOrg) {
    redirectToOrg(+organizationId);
  }

  return (
    <div className="forbidden-page">
      <div className="dialog">
        <a href={TEAMSNAP_URL}>
          <img src={TEAMSNAP_URL + '/images/teamsnap_title_nobg.png'} alt="TeamSnap" />
        </a>
        <h1>Whoops! Looks like this organization has been disabled.</h1>
        <p className="u-padTopLg u-padBottomLg" dangerouslySetInnerHTML={{ __html: disabledMessage }} />
      </div>
    </div>
  );
};

export default DisabledOrg;
